import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { useSelector, useDispatch } from '@grandvisionhq/state';
import { selectShippingMethod } from '../StepShipping/actions.js';
import { getSelectedShippingMethod } from '../StepShipping/selectors.js';

const useSyncCartShippingMethodWithReduxAfterTabFocus = ()=>{
    const [hasRefocussed, setHasRefocussed] = React.useState(false);
    const shippingMethod = useSelector(getSelectedShippingMethod);
    const { cart , refetch  } = Context.useCart();
    const dispatch = useDispatch();
    // Refresh the cart when the user comes back from another tab
    React.useEffect(()=>{
        const cb = ()=>{
            setHasRefocussed(true);
            refetch();
        };
        window.addEventListener('focus', cb);
        return ()=>{
            window.removeEventListener('focus', cb);
        };
    });
    // If the user changed the shipping method in another tab, refresh the shipping method here as well
    React.useEffect(()=>{
        if (hasRefocussed && (shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.method) !== (cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key)) {
            dispatch(selectShippingMethod({
                shippingMethod: {
                    method: cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key,
                    isValid: true,
                    isTouched: true
                }
            }));
        }
    }, [
        cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key,
        dispatch,
        shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.method,
        hasRefocussed
    ]);
};

export { useSyncCartShippingMethodWithReduxAfterTabFocus };
//# sourceMappingURL=use-sync-cart-shipping-method-with-redux.js.map
